var map = {
	"./assets/image/sgtest/result/kurisu/tip_2.png": "810c",
	"./assets/image/sgtest/result/mayuri/tip_2.png": "2697",
	"./assets/image/sgtest/result/rintarou/tip_2.png": "4786",
	"./assets/image/sgtest/result/suzuha/tip_2.png": "9f5a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "98aa";